import { render, staticRenderFns } from "./NewFamilyHub.vue?vue&type=template&id=482d2a23&scoped=true&"
import script from "./NewFamilyHub.vue?vue&type=script&lang=ts&"
export * from "./NewFamilyHub.vue?vue&type=script&lang=ts&"
import style0 from "./NewFamilyHub.vue?vue&type=style&index=0&id=482d2a23&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482d2a23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
